import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnChanges {
  @Input() rating = 0;
  starWidth = 0;
  defaultWidth = 120;
  constructor() { }

  ngOnChanges() {
    this.starWidth = this.rating * this.defaultWidth / 5;
  }
}
